import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/401k-contribution-calculator',
  component: () => import('../../routes/FourOhOneKContributionCalculator.svelte'),
  card: {
    id: '401k-contribution-calculator',
    title: '401(k) Contribution',
    description: 'Calculate your annual 401(k) contributions with employer match. See how much you can save with salary increases over time.',
    icon: 'savings',
    iconBgClass: 'bg-indigo-50',
    iconTextClass: 'text-indigo-600',
    href: '/401k-contribution-calculator',
    category: 'Retirement & Tax',
  },
  seo: {
    title: '401(k) Contribution Calculator – Employee & Employer Match',
    description: 'Free 401(k) contribution calculator to estimate annual employee contributions, employer match, and total savings. Includes salary increase projections.',
  },
};

export default meta;
